<template>
  <div class="home-container">
    <!-- ===== Hero Carousel - Shipex 风格 ===== -->
    <section class="hero-section-wrap">
      <div class="hero-carousel" id="heroCarousel">
        <!-- Slide 1: Airplane logistics -->
        <div class="hero-slide" :class="{ active: currentSlide === 0 }" data-index="0">
          <img class="hero-slide-img" :src="require('@/assets/images/demo-01-slide-2.jpg')" :alt="$t('homeHero.slides[0].alt')" />
          <div class="hero-slide-overlay"></div>
          <div class="hero-content">
            <div class="hero-badge">{{ $t('homeHero.slides[0].badge') }}</div>
            <h1 class="hero-headline" v-html="$t('homeHero.slides[0].headline')"></h1>
            <div class="hero-bottom">
              <div class="hero-divider-line"></div>
              <p class="hero-desc">{{ $t('homeHero.slides[0].desc') }}</p>
            </div>
            <div class="hero-cta">
              <router-link to="/services/shipping" class="hero-cta-btn">
                {{ $t('homeHero.slides[0].cta') }}
                <span class="hero-cta-icon">
                  <svg viewBox="0 0 24 24" width="14" height="14"><path d="M5 12h14M12 5l7 7-7 7" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg>
                </span>
              </router-link>
            </div>
          </div>
        </div>

        <!-- Slide 2: Dangerous goods -->
        <div class="hero-slide" :class="{ active: currentSlide === 1 }" data-index="1">
          <img class="hero-slide-img" :src="require('@/assets/images/demo-02-slide1.jpg')" :alt="$t('homeHero.slides[1].alt')" />
          <div class="hero-slide-overlay"></div>
          <div class="hero-content">
            <div class="hero-badge">{{ $t('homeHero.slides[1].badge') }}</div>
            <h1 class="hero-headline" v-html="$t('homeHero.slides[1].headline')"></h1>
            <div class="hero-bottom">
              <div class="hero-divider-line"></div>
              <p class="hero-desc">{{ $t('homeHero.slides[1].desc') }}</p>
            </div>
            <div class="hero-cta">
              <router-link to="/contact/business" class="hero-cta-btn">
                {{ $t('homeHero.slides[1].cta') }}
                <span class="hero-cta-icon">
                  <svg viewBox="0 0 24 24" width="14" height="14"><path d="M5 12h14M12 5l7 7-7 7" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg>
                </span>
              </router-link>
            </div>
          </div>
        </div>

        <!-- Slide 3: Cold chain -->
        <div class="hero-slide" :class="{ active: currentSlide === 2 }" data-index="2">
          <img class="hero-slide-img" :src="require('@/assets/images/demo-01-slide-3.jpg')" :alt="$t('homeHero.slides[2].alt')" />
          <div class="hero-slide-overlay"></div>
          <div class="hero-content">
            <div class="hero-badge">{{ $t('homeHero.slides[2].badge') }}</div>
            <h1 class="hero-headline" v-html="$t('homeHero.slides[2].headline')"></h1>
            <div class="hero-bottom">
              <div class="hero-divider-line"></div>
              <p class="hero-desc">{{ $t('homeHero.slides[2].desc') }}</p>
            </div>
            <div class="hero-cta">
              <router-link to="/services/refrigerated" class="hero-cta-btn">
                {{ $t('homeHero.slides[2].cta') }}
                <span class="hero-cta-icon">
                  <svg viewBox="0 0 24 24" width="14" height="14"><path d="M5 12h14M12 5l7 7-7 7" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg>
                </span>
              </router-link>
            </div>
          </div>
        </div>

        <!-- Right edge vertical indicators -->
        <div class="hero-indicators">
          <button class="hero-indicator" :class="{ active: currentSlide === 0 }" @click="goToSlide(0)"></button>
          <button class="hero-indicator" :class="{ active: currentSlide === 1 }" @click="goToSlide(1)"></button>
          <button class="hero-indicator" :class="{ active: currentSlide === 2 }" @click="goToSlide(2)"></button>
        </div>

        <!-- Left/Right arrows -->
        <!-- <button class="hero-arrow hero-arrow--left" @click="prevSlide">
          <svg viewBox="0 0 24 24"><path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg>
        </button>
        <button class="hero-arrow hero-arrow--right" @click="nextSlide">
          <svg viewBox="0 0 24 24"><path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg>
        </button> -->

        <!-- Scroll hint -->
        <div class="hero-scroll-hint">
          <div class="hero-scroll-line"></div>
        </div>
      </div>
    </section>
   <!-- ===== About Section ===== -->
<section class="about-section" id="about">
  <div class="container">
    <div class="about-row-new">
      <div class="about-left reveal">
        <h4 class="about-label">{{ $t('aboutFst.companyIntro.title') }}</h4>
        <h1 class="about-heading">{{ $t('aboutFst.companyIntro.subtitle') }}</h1>
        
        <div class="feature-items">
          <div v-for="(service, index) in $t('aboutFst.quickServices')" :key="index" class="feature-item">
            <span :class="service.icon"></span>
            <h5>{{ service.title }}</h5>
          </div>
        </div>

        <p class="about-desc">
          {{ $t('aboutFst.companyIntro.qualifications.part1') }}
          <strong class="text-primary">{{ $t('aboutFst.companyIntro.qualifications.highlight') }}</strong>
          {{ $t('aboutFst.companyIntro.qualifications.part2') }}
        </p>

        <router-link class="btn btn-primary btn-lg" to="/contact/business">{{ $t('contactUs') }}</router-link>
      </div>
      
      <div class="about-right reveal reveal-delay-1">
        <div class="about-collage">
          <div class="collage-main">
            <img v-lazy-img="aboutImg1" alt="about-img-1" />
          </div>
          <!-- <div class="collage-sub">
            <img :src="aboutImg2" alt="about-img-2" />
          </div>
          <div class="experience-badge">
            <span class="badge-number">20+</span>
            <span class="badge-label">{{ $t('aboutFst.stats.airlines') }}</span>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</section>

    <!-- ===== Stats Section ===== -->
    <section class="stats-section reveal">
      <div class="container stats-row">
        <div class="stat-card" v-for="(stat, index) in statsList" :key="stat.key">
          <div class="stat-number">{{ stat.number }}</div>
          <div class="stat-label">{{ stat.label }}</div>
        </div>
      </div>
    </section>


    <!-- ===== Services Section ===== -->
    <section class="services-section-wrap" id="services">
      <div class="container">
        <div class="section-title text-center reveal">
          <h4 class="text-primary">{{ $t('homeFst.services.tag') }}</h4>
          <h1 class="display-6">{{ $t('homeFst.services.title') }}</h1>
        </div>

        <div class="services-card-grid">
          <div v-for="(service, index) in serviceList" :key="index" class="service-card reveal" :style="{ transitionDelay: (index * 0.1) + 's' }">
            <!-- 默认状态：左侧内容 + 右侧图片 -->
            <div class="service-card-content">
              <div class="service-card-icon">
                <i :class="service.icon"></i>
              </div>
              <span class="service-card-number">{{ String(index + 1).padStart(2, '0') }}</span>
              <h3 class="service-card-title">{{ service.title }}</h3>
              <p class="service-card-desc">{{ service.desc }}</p>
              <router-link :to="service.link || '# '" class="service-card-arrow">
                <i class="el-icon-top-right"></i>
              </router-link>
            </div>
            <div class="service-card-image">
              <img v-lazy-img="service.image" :alt="service.title" />
            </div>
            <!-- 悬停浮层：图片铺满 + 内容覆盖 -->
            <div class="service-card-hover-overlay">
              <img v-lazy-img="service.image" :alt="service.title" class="hover-bg-img" />
              <div class="hover-overlay-dark"></div>
              <div class="hover-overlay-content">
                <span class="hover-number">{{ String(index + 1).padStart(2, '0') }}</span>
                <h3 class="hover-title">{{ service.title }}</h3>
                <p class="hover-desc">{{ service.hoverDesc || service.desc }}</p>
                <ul class="hover-features" v-if="service.features && service.features.length">
                  <li v-for="(feature, fi) in service.features" :key="fi">
                    <i class="el-icon-check"></i><span>{{ feature }}</span>
                  </li>
                </ul>
                <!-- <router-link :to="service.link || '# '" class="hover-arrow">
                  <i class="el-icon-top-right"></i>
                </router-link> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>


    <!-- ===== Branches / Network Section ===== -->
    <section class="branches-section">
      <div class="branches-bg-decoration"></div>
      <div class="container">
        <div class="section-title text-center reveal">
          <h4 class="text-primary">{{ $t('aboutFst.branches.title') }}</h4>
          <h1 class="display-6">{{ $t('aboutFst.branches.subtitle') }}</h1>
        </div>

        <!-- 分支机构快捷切换标签 -->
        <!-- <div class="branch-tabs reveal">
          <button
            v-for="b in branches"
            :key="b.key"
            class="branch-tab"
            :class="{ active: activeBranch === b.key }"
            @click="activeBranch = b.key"
          >{{ b.city }}</button>
        </div> -->

        <!-- 国内交互式地图 -->
        <div class="map-layout reveal">
          <div class="china-map-wrap">
            <div ref="chinaMap" class="china-map-echarts"></div>
            <div class="map-hint">
              <i class="el-icon-info"></i> {{ $t('homeHero.mapHint') }}
            </div>
          </div>

          <!-- 详情面板 -->
          <div class="branch-detail-panel">
            <div
              v-if="currentBranch.images && currentBranch.images.length"
              class="detail-image-zone"
              :style="{ backgroundImage: 'url(' + currentBranch.images[0] + ')' }"
            >
              <div class="image-fade"></div>
            </div>
            <transition name="fade-slide" mode="out-in">
              <div :key="activeBranch" class="detail-content">
                <div class="detail-header">
                  <div class="detail-city-badge">
                    <i class="el-icon-map-location"></i>
                    {{ currentBranch.city }}
                  </div>
                  <div class="detail-year">{{ currentBranch.year }}{{ $t('aboutFst.common.established') }}</div>
                </div>
                <p class="detail-desc">{{ currentBranch.desc }}</p>
                <div class="detail-stats">
                  <div class="detail-stat">
                    <div class="stat-icon-wrap">
                      <i class="el-icon-office-building"></i>
                    </div>
                    <div class="stat-info">
                      <div class="stat-label">{{ $t('aboutFst.common.officeArea') }}</div>
                      <div class="stat-value">{{ currentBranch.officeArea }}</div>
                    </div>
                  </div>
                  <div class="detail-stat">
                    <div class="stat-icon-wrap">
                      <i class="el-icon-house"></i>
                    </div>
                    <div class="stat-info">
                      <div class="stat-label">{{ $t('aboutFst.common.warehouseArea') }}</div>
                      <div class="stat-value">{{ currentBranch.warehouseArea }}</div>
                    </div>
                  </div>
                </div>
                <div class="detail-contact" v-if="currentBranch.contact">
                  <div class="contact-item">
                    <i class="el-icon-user"></i>
                    <span>{{ currentBranch.contact }}</span>
                  </div>
                  <div class="contact-item">
                    <i class="el-icon-phone"></i>
                    <span>{{ currentBranch.phone }}</span>
                  </div>
                  <div class="contact-item">
                    <i class="el-icon-map-location"></i>
                    <span>{{ currentBranch.address }}</span>
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </div>

      </div>
    </section>

    <!-- ===== Partners Section ===== -->
    <section class="partners-section">
      <div class="container">
        <div class="section-title text-center reveal">
          <h4 class="text-primary">{{ $t('homeFst.partners.title') }}</h4>
          <h1 class="display-6">{{ $t('homeFst.partners.subtitle') }}</h1>
        </div>

        <div class="partner-track-wrap reveal" v-if="airlineLogos.length > 0">
          <h5 class="track-label">{{ $t('homeFst.partners.airlineTitle') }}</h5>
          <div class="partner-track">
            <div class="partner-track-inner">
              <img v-for="(logo, i) in airlineLogos" :key="'a'+i" v-lazy-img="logo.src" :alt="logo.name" class="partner-logo" />
              <img v-for="(logo, i) in airlineLogos" :key="'a2'+i" v-lazy-img="logo.src" :alt="logo.name" class="partner-logo" />
            </div>
          </div>
        </div>

        <div class="partner-track-wrap reveal reveal-delay-1" v-if="shippingLogos.length > 0">
          <h5 class="track-label">{{ $t('homeFst.partners.shippingTitle') }}</h5>
          <div class="partner-track partner-track-reverse">
            <div class="partner-track-inner">
              <img v-for="(logo, i) in shippingLogos" :key="'s'+i" v-lazy-img="logo.src" :alt="logo.name" class="partner-logo" />
              <img v-for="(logo, i) in shippingLogos" :key="'s2'+i" v-lazy-img="logo.src" :alt="logo.name" class="partner-logo" />
            </div>
          </div>
        </div>
      </div>
    </section>



  </div>
</template>

<script>
  import * as echarts from 'echarts';

  const CHINA_MAP_URL = '/data/china.json';

  export default {
    name: 'Home',
    data() {
      return {
        email: '',
        imagesLoaded: false,
        observerInstances: [],
        aboutImg1: require('@/assets/images/北京办公室.jpg'),
        aboutImg2: require('@/assets/images/b3.png'),
        activeBranch: 'beijing',
        chinaMapInstance: null,
        currentSlide: 0,
        slideInterval: null,
        airlineLogos: [
                  { name: 'Air China', src: require('@/assets/images/air-china.jpg') },
                  { name: 'China Eastern', src: require('@/assets/images/china-eastern.png') },
                  { name: 'China Southern', src: require('@/assets/images/china-southern.jpg') },
                  { name: 'Sichuan Airlines', src: require('@/assets/images/sichuan-air.png') },
                  { name: 'Emirates', src: require('@/assets/images/ek.jpg') },
                  { name: 'Qatar Airways', src: require('@/assets/images/qatar.jpg') },
                  { name: 'Etihad Airways', src: require('@/assets/images/Etihad-Airways.png') },
                  { name: 'Lufthansa', src: require('@/assets/images/LH.jpg') },
                  { name: 'Swiss Air', src: require('@/assets/images/Swiss-Air.png') },
                  { name: 'British Airways', src: require('@/assets/images/british-Airways.png') },
                  { name: 'Air France KLM', src: require('@/assets/images/Air-FranceKLM.png') },
                  { name: 'Thai Airways', src: require('@/assets/images/thai.jpg') },
                  { name: 'United Airlines', src: require('@/assets/images/united.png') },
                ],
                shippingLogos: [
                  { name: 'COSCO', src: require('@/assets/images/cosco.png') },
                  { name: 'Maersk', src: require('@/assets/images/maersk.png') },
                  { name: 'MSC', src: require('@/assets/images/msc.png') },
                  { name: 'Evergreen', src: require('@/assets/images/evergreen.png') },
                  { name: 'CMA CGM', src: require('@/assets/images/cmacgm.png') },
                  { name: 'OOCL', src: require('@/assets/images/oocl.jpg') },
                  { name: 'ONE', src: require('@/assets/images/one.png') },
                  { name: 'Yang Ming', src: require('@/assets/images/yml.png') },
                  { name: 'Wan Hai', src: require('@/assets/images/wanhai.png') },
                ],
      };
    },
    computed: {
      branches() {
        return [
          {
            key: 'beijing',
            city: this.$t('aboutFst.branches.beijing.city'),
            cityWithYear: this.$t('aboutFst.branches.beijing.cityWithYear'),
            year: this.$t('aboutFst.branches.beijing.year'),
            desc: this.$t('aboutFst.branches.beijing.desc'),
            officeArea: this.$t('aboutFst.branches.beijing.officeArea'),
            warehouseArea: this.$t('aboutFst.branches.beijing.warehouseArea'),
            lng: 116.4074, lat: 39.9042,
            contact: this.$t('homeHero.branches.beijing.contact'),
            phone: this.$t('homeHero.branches.beijing.phone'),
            address: this.$t('homeHero.branches.beijing.address'),
            images: [
              require('@/assets/images/北京办公室.jpg'),
              require('@/assets/images/北京办公室2.jpg'),
            ]
          },
          {
            key: 'shanghai',
            city: this.$t('aboutFst.branches.shanghai.city'),
            cityWithYear: this.$t('aboutFst.branches.shanghai.cityWithYear'),
            year: this.$t('aboutFst.branches.shanghai.year'),
            desc: this.$t('aboutFst.branches.shanghai.desc'),
            officeArea: this.$t('aboutFst.branches.shanghai.officeArea'),
            warehouseArea: this.$t('aboutFst.branches.shanghai.warehouseArea'),
            lng: 121.4737, lat: 31.2304,
            contact: this.$t('homeHero.branches.shanghai.contact'),
            phone: this.$t('homeHero.branches.shanghai.phone'),
            address: this.$t('homeHero.branches.shanghai.address'),
            images: [
              require('@/assets/images/shky.png'),
              require('@/assets/images/shhy.jpg'),
            ]
          },
          {
            key: 'guangzhou',
            city: this.$t('aboutFst.branches.guangzhou.city'),
            cityWithYear: this.$t('aboutFst.branches.guangzhou.cityWithYear'),
            year: this.$t('aboutFst.branches.guangzhou.year'),
            desc: this.$t('aboutFst.branches.guangzhou.desc'),
            officeArea: this.$t('aboutFst.branches.guangzhou.officeArea'),
            warehouseArea: this.$t('aboutFst.branches.guangzhou.warehouseArea'),
            lng: 113.2644, lat: 23.1291,
            contact: this.$t('homeHero.branches.guangzhou.contact'),
            phone: this.$t('homeHero.branches.guangzhou.phone'),
            address: this.$t('homeHero.branches.guangzhou.address'),
            images: [
              require('@/assets/images/gzbgs.jpg'),
              require('@/assets/images/gz3.jpg'),
            ]
          },
          {
            key: 'zhengzhou',
            city: this.$t('aboutFst.branches.zhengzhou.city'),
            cityWithYear: this.$t('aboutFst.branches.zhengzhou.cityWithYear'),
            year: this.$t('aboutFst.branches.zhengzhou.year'),
            desc: this.$t('aboutFst.branches.zhengzhou.desc'),
            officeArea: this.$t('aboutFst.branches.zhengzhou.officeArea'),
            warehouseArea: this.$t('aboutFst.branches.zhengzhou.warehouseArea'),
            lng: 113.6254, lat: 34.7466,
            contact: this.$t('homeHero.branches.zhengzhou.contact'),
            phone: this.$t('homeHero.branches.zhengzhou.phone'),
            address: this.$t('homeHero.branches.zhengzhou.address'),
            images: [
              require('@/assets/images/郑州办公室.jpg'),
            ]
          },
          {
            key: 'chengdu',
            city: this.$t('aboutFst.branches.chengdu.city'),
            cityWithYear: this.$t('aboutFst.branches.chengdu.cityWithYear'),
            year: this.$t('aboutFst.branches.chengdu.year'),
            desc: this.$t('aboutFst.branches.chengdu.desc'),
            officeArea: this.$t('aboutFst.branches.chengdu.officeArea'),
            warehouseArea: this.$t('aboutFst.branches.chengdu.warehouseArea'),
            lng: 104.0665, lat: 30.5728,
            contact: this.$t('homeHero.branches.chengdu.contact'),
            phone: this.$t('homeHero.branches.chengdu.phone'),
            address: this.$t('homeHero.branches.chengdu.address'),
            images: [
              require('@/assets/images/成都办公室1.jpg'),
              require('@/assets/images/cdkf1.jpg'),
            ]
          }
        ];
      },
      statsList() {
        return [
          { key: 'years', number: '20+', label: this.$t('homeFst.stats.years') },
          { key: 'airlines', number: '260+', label: this.$t('homeFst.stats.airlines') },
          { key: 'routes', number: '6200+', label: this.$t('homeFst.stats.routes') },
          { key: 'customers', number: '12000+', label: this.$t('homeFst.stats.customers') },
        ];
      },
      newsList() {
        return this.$t('homeFst.news.items');
      },
      currentBranch() {
        return this.branches.find(b => b.key === this.activeBranch) || this.branches[0];
      },
      memberships() {
        return [
          { img: require('@/assets/images/iata1.png'), name: this.$t('aboutFst.memberships.iata') },
          { img: require('@/assets/images/logo_wcaworld2.png'), name: this.$t('aboutFst.memberships.wca') },
          { img: require('@/assets/images/logo_wcaworld1.png'), name: this.$t('aboutFst.memberships.wcaDangerous') },
          { img: require('@/assets/images/jc1.png'), name: this.$t('aboutFst.memberships.jctrans') },
          { img: require('@/assets/images/jc2.jpg'), name: this.$t('aboutFst.memberships.jctransCert') },
        ];
      },
      serviceList() {
        const rawServices = this.$t('homeFst.services.list');
        const icons = [
          'iconfont icon-xuehua',
          'iconfont icon-kulou',
          'iconfont icon-cross',
          'iconfont icon-shandian',
          'iconfont icon-diaoche',
          'iconfont icon-siyoudingzhihua',
        ];
        const images = [
          require('@/assets/images/ll.png'),
          require('@/assets/images/wxp.png'),
          require('@/assets/images/yy.png'),
          require('@/assets/images/dd.png'),
          require('@/assets/images/cdj.png'),
          require('@/assets/images/dingzhi.png'),
        ];
        const links = [
          '/services/shipping',
          '/services/refrigerated',
          '/services/operable',
          '/services/consultation',
          '/services/shipping',
          '/services/consultation',
        ];
        return rawServices.map((s, i) => ({
          ...s,
          icon: icons[i],
          iconColor: '#FF6A00',
          image: images[i],
          link: links[i],
          hoverDesc: s.desc,
          features: s.features || [],
        }));
      },
    },
    watch: {
      activeBranch: function () {
        this.$nextTick(this.renderMap);
      },
    },
    methods: {
      goToSlide(index) {
        this.stopAutoplay();
        this.currentSlide = index;
        this.startAutoplay();
      },
      nextSlide() {
        this.currentSlide = (this.currentSlide + 1) % 3;
      },
      prevSlide() {
        this.stopAutoplay();
        this.currentSlide = (this.currentSlide - 1 + 3) % 3;
        this.startAutoplay();
      },
      startAutoplay() {
        this.slideInterval = setInterval(this.nextSlide, 6000);
      },
      stopAutoplay() {
        if (this.slideInterval) {
          clearInterval(this.slideInterval);
          this.slideInterval = null;
        }
      },
      initRevealObserver() {
        if (!this.$el || !this.$el.querySelectorAll) return;
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('revealed');
                observer.unobserve(entry.target);
              }
            });
          },
          { threshold: 0.1, rootMargin: '0px 0px -60px 0px' }
        );
        this.$el.querySelectorAll('.reveal').forEach((el) => observer.observe(el));
        this.observerInstances.push(observer);
      },
      scrollTop() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      },
      initChinaMap() {
        if (!this.$refs.chinaMap) return;
        this.chinaMapInstance = echarts.init(this.$refs.chinaMap);
        fetch(CHINA_MAP_URL)
          .then(function (res) { return res.json(); })
          .then(function (geoJson) {
            echarts.registerMap('china', geoJson);
            this.renderMap();
          }.bind(this))
          .catch(function () {
            console.error('中国地图 GeoJSON 加载失败');
          });
      },
      renderMap() {
        if (!this.chinaMapInstance) return;
        var scatterData = this.branches.map(function (b) {
          return { name: b.city, value: [b.lng, b.lat], key: b.key };
        });
        var self = this;
        var bj = this.branches.find(function (x) { return x.key === 'beijing'; });
        var linesData = this.branches
          .filter(function (b) { return b.key !== 'beijing'; })
          .map(function (b) {
            return {
              coords: [[bj.lng, bj.lat], [b.lng, b.lat]],
              lineStyle: {
                color: {
                  type: 'linear', x: 0, y: 0, x2: 1, y2: 0,
                  colorStops: [
                    { offset: 0, color: 'rgba(0,82,204,.6)' },
                    { offset: 1, color: 'rgba(59,127,255,.3)' }
                  ]
                },
                width: 1.5,
                curveness: 0.2,
              }
            };
          });
        var allRegions = this.getProvinceColorMap();
        var activeKey = this.activeBranch;
        var option = {
          backgroundColor: 'transparent',
          tooltip: {
            trigger: 'item',
            backgroundColor: 'rgba(10,22,40,.88)',
            borderColor: 'rgba(0,82,204,.3)',
            borderWidth: 1,
            textStyle: { color: '#fff', fontSize: 13 },
            formatter: function (params) {
              if (params.seriesType === 'scatter' || params.seriesType === 'effectScatter') {
                return '<b>' + params.name + '</b><br/>点击查看详情';
              }
              return '';
            }
          },
          geo: {
            map: 'china',
            roam: false,
            layoutSize: '92%',
            layoutCenter: ['50%', '50%'],
            label: { show: false },
            itemStyle: {
              areaColor: '#E2E8F0',
              borderColor: '#fff',
              borderWidth: 2
            },
            emphasis: {
              itemStyle: { areaColor: 'rgba(0,82,204,.12)' },
              label: { show: false }
            },
            regions: allRegions,
            select: { disabled: true }
          },
          series: [
            {
              type: 'lines',
              coordinateSystem: 'geo',
              data: linesData,
              silent: true,
              polyline: false,
              effect: {
                show: true,
                period: 5,
                trailLength: 0.25,
                symbol: 'arrow',
                symbolSize: 6,
                color: '#0052CC'
              },
              zlevel: 1
            },
            {
              type: 'effectScatter',
              coordinateSystem: 'geo',
              data: scatterData.filter(function (d) { return d.key === activeKey; }),
              symbolSize: 18,
              showEffectOn: 'render',
              rippleEffect: { brushType: 'stroke', scale: 4, period: 3, number: 2 },
              itemStyle: { color: '#0052CC', shadowBlur: 16, shadowColor: 'rgba(0,82,204,.45)' },
              label: {
                show: true, position: 'top', formatter: '{b}',
                fontSize: 14, fontWeight: 'bold', color: '#0052CC', distance: 12,
                textShadowColor: 'rgba(255,255,255,.8)', textShadowBlur: 4
              },
              zlevel: 2
            },
            {
              type: 'scatter',
              coordinateSystem: 'geo',
              data: scatterData.filter(function (d) { return d.key !== activeKey; }),
              symbolSize: 14,
              itemStyle: {
                color: '#fff',
                borderColor: '#0052CC',
                borderWidth: 2.5,
                shadowBlur: 8,
                shadowColor: 'rgba(0,82,204,.2)'
              },
              label: {
                show: true, position: 'top', formatter: '{b}',
                fontSize: 12, fontWeight: 500, color: '#3A4D60', distance: 10,
                textShadowColor: 'rgba(255,255,255,.9)', textShadowBlur: 3
              },
              emphasis: {
                scale: 1.6,
                itemStyle: {
                  color: '#0052CC', borderColor: '#fff', borderWidth: 3,
                  shadowBlur: 14, shadowColor: 'rgba(0,82,204,.5)'
                },
                label: { color: '#0052CC', fontWeight: 'bold', fontSize: 14 }
              },
              zlevel: 2
            }
          ]
        };
        this.chinaMapInstance.setOption(option, true);
        this.chinaMapInstance.off('click');
        this.chinaMapInstance.on('click', function (params) {
          if (params.seriesType === 'scatter' || params.seriesType === 'effectScatter') {
            var branch = self.branches.find(function (b) { return b.city === params.name; });
            if (branch) self.activeBranch = branch.key;
          }
        });
      },
      getProvinceColorMap() {
        // 粉彩区域配色 — 柔和区分各地理大区
        var regionColors = {
          north:     '#A0C4FF',   // 华北 - 柔蓝
          northeast: '#B5E48C',   // 东北 - 嫩绿
          east:      '#FFBE76',   // 华东 - 暖杏
          central:   '#FF8FAB',   // 华中 - 柔粉
          south:     '#7EC8E3',   // 华南 - 天青
          southwest: '#C3A6FF',   // 西南 - 薰衣草
          northwest: '#FFD166',   // 西北 - 柔金
          other:     '#CBD5E1',   // 港澳台 - 银灰
        };
        var provinceRegionMap = {
          '北京市': 'north','天津市': 'north','河北省': 'north','山西省': 'north','内蒙古自治区': 'north',
          '辽宁省': 'northeast','吉林省': 'northeast','黑龙江省': 'northeast',
          '上海市': 'east','江苏省': 'east','浙江省': 'east','安徽省': 'east','福建省': 'east','江西省': 'east','山东省': 'east',
          '河南省': 'central','湖北省': 'central','湖南省': 'central',
          '广东省': 'south','广西壮族自治区': 'south','海南省': 'south',
          '重庆市': 'southwest','四川省': 'southwest','贵州省': 'southwest','云南省': 'southwest','西藏自治区': 'southwest',
          '陕西省': 'northwest','甘肃省': 'northwest','青海省': 'northwest','宁夏回族自治区': 'northwest','新疆维吾尔自治区': 'northwest',
          '台湾省': 'other','香港特别行政区': 'other','澳门特别行政区': 'other',
        };
        var self = this;
        var activeProvince = this.getProvinceName(this.activeBranch);
        return Object.keys(provinceRegionMap).map(function (name) {
          var region = provinceRegionMap[name];
          var baseColor = regionColors[region] || '#E2E8F0';
          var isActive = name === activeProvince;
          return {
            name: name,
            itemStyle: {
              areaColor: isActive ? '#0052CC' : baseColor,
              borderColor: isActive ? '#003D99' : '#fff',
              borderWidth: isActive ? 2 : 2,
              shadowColor: isActive ? 'rgba(0,82,204,.35)' : 'transparent',
              shadowBlur: isActive ? 12 : 0
            },
            emphasis: {
              itemStyle: {
                areaColor: isActive ? '#003D99' : baseColor,
                borderColor: isActive ? '#003D99' : '#0052CC',
                borderWidth: isActive ? 2 : 1.5,
                shadowColor: 'rgba(0,82,204,.2)',
                shadowBlur: 8
              },
              label: { show: false }
            }
          };
        });
      },
      getProvinceName(key) {
        return (this.$t('homeHero.provinceNames')[key]) || '';
      },
    },
    mounted() {
      this.$nextTick(function () {
        this.initRevealObserver();
        this.initChinaMap();
        this.startAutoplay();
      }.bind(this));
      this._mapResizeHandler = function () {
        if (this.chinaMapInstance) this.chinaMapInstance.resize();
      }.bind(this);
      window.addEventListener('resize', this._mapResizeHandler);
    },
    beforeDestroy() {
      this.observerInstances.forEach(function (obs) { obs.disconnect(); });
      window.removeEventListener('resize', this._mapResizeHandler);
      if (this.chinaMapInstance) {
        this.chinaMapInstance.dispose();
        this.chinaMapInstance = null;
      }
      this.stopAutoplay();
    },
  };
</script>

<style lang="scss" scoped>
  /* ===== Theme tokens ===== */
  /* 品牌视觉规范：品牌蓝 + 烫银色 */
  $primary: #0052CC; // 品牌蓝（主色）
  $primary-dark: #0043A8; // 品牌蓝深色
  $primary-light: #3B7FFF; // 品牌蓝浅色
  $silver: #8E9EAB; // 烫银色（辅色）
  $silver-light: #A8B5C0; // 烫银色浅色
  $silver-dark: #758694; // 烫银色深色
  $dark: #0A1628; // 深蓝黑色
  $light: #F4F7FB; // 浅灰背景
  $body: #5B6C7F; // 正文颜色
  $heading: #0A1628; // 标题颜色

  .home-container {
    width: 100%;
    overflow: hidden;
    background: #ffffff;
    color: $body;
    font-family: 'PingFang SC', 'Microsoft YaHei', 'Noto Sans SC', 'Rubik', 'Poppins', system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
  }

  /* shared atoms */
  .text-primary {
    color: $primary !important;
  }

  .text-primary-light {
    color: lighten($primary, 10%) !important;
  }

  .text-white {
    color: #fff !important;
  }

  .text-muted-light {
    color: rgba(255, 255, 255, 0.7);
  }

  .display-6 {
    font-size: 1.8rem;
    font-weight: 700;
    color: $heading;
    margin-bottom: 1.25rem;
    line-height: 1.2;
  }

  .section-title {
    margin-bottom: 1.5rem;

    h4 {
      font-size: 0.95rem;
      letter-spacing: 2px;
      font-weight: 600;
      margin-bottom: .75rem;
      color: $primary;
    }

    .display-6 {
      margin-bottom: 1rem;
    }
  }

  .text-center {
    text-align: center;
  }

  .container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 40px;
  }

  .btn {
    display: inline-block;
    padding: 12px 28px;
    border: none;
    border-radius: 4px;
    font-weight: 500;
    cursor: pointer;
    text-decoration: none;
    letter-spacing: .5px;
    transition: all .3s ease;
    font-size: 14px;

    &.btn-lg {
      padding: 16px 36px;
      font-size: 15px;
    }

    &.btn-primary {
      background: $primary;
      color: #fff;

      &:hover {
        background: $primary-dark;
        transform: translateY(-2px);
        box-shadow: 0 8px 20px rgba(0, 82, 204, .3);
      }
    }

    &.btn-light {
      background: #fff;
      color: $heading;

      &:hover {
        background: $light;
        transform: translateY(-2px);
      }
    }
  }

  /* ===== Hero Carousel - Shipex 风格 ===== */
  .hero-section-wrap {
    position: relative;
    width: 100%;
  }

  .hero-carousel {
    position: relative;
    width: 100%;
    height: 98vh;
    min-height: 600px;
    overflow: hidden;
    border-radius: 20px;
    background: #0a1628;
  }

  .hero-slide {
    position: absolute;
    inset: 0;
    opacity: 0;
    transition: opacity 1.4s ease-in-out;
    z-index: 1;

    &.active {
      opacity: 1;
      z-index: 2;
    }
  }

  .hero-slide-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .hero-slide-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(
      135deg,
      rgba(10, 22, 40, 0.72) 0%,
      rgba(10, 22, 40, 0.45) 40%,
      rgba(10, 22, 40, 0.3) 60%,
      rgba(10, 22, 40, 0.55) 100%
    );
  }

  /* Hero content container */
  .hero-content {
    position: absolute;
    inset: 0;
    z-index: 3;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 8%;
    max-width: 1400px;
    margin: 0 auto;
  }

  /* Badge */
  .hero-badge {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    letter-spacing: 3px;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.9);
    border: 1px solid rgba(255, 255, 255, 0.4);
    padding: 8px 22px;
    border-radius: 30px;
    margin-bottom: 28px;
    font-weight: 600;
    background: rgba(255, 255, 255, 0.06);
    backdrop-filter: blur(6px);
    width: fit-content;
  }

  /* Headline */
  .hero-headline {
    font-size: clamp(2.4rem, 5vw, 4.2rem);
    font-weight: 800;
    color: #fff;
    line-height: 1.1;
    margin-bottom: 32px;
    max-width: 700px;
    text-shadow: 0 2px 40px rgba(0, 0, 0, 0.3);
  }

  /* Divider + description */
  .hero-bottom {
    display: flex;
    align-items: flex-end;
    gap: 60px;
    max-width: 900px;
  }

  .hero-divider-line {
    flex: 0 0 80px;
    height: 1px;
    background: rgba(255, 255, 255, 0.35);
    margin-bottom: 12px;
  }

  .hero-desc {
    font-size: 15px;
    line-height: 1.8;
    color: rgba(255, 255, 255, 0.8);
    max-width: 420px;
    margin-bottom: 0;
  }

  /* CTA Button */
  .hero-cta {
    margin-top: 40px;
  }

  .hero-cta-btn {
    display: inline-flex;
    align-items: center;
    gap: 12px;
    padding: 16px 36px;
    background: #fff;
    color: #0d1b2a;
    font-size: 14px;
    font-weight: 700;
    border-radius: 30px;
    transition: all 0.3s ease;
    letter-spacing: 0.5px;
    text-decoration: none;

    &:hover {
      background: #f0f4f8;
      transform: translateY(-2px);
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
    }
  }

  .hero-cta-icon {
    width: 32px;
    height: 32px;
    background: #0052CC;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.3s ease;

    svg {
      width: 14px;
      height: 14px;
    }
  }

  .hero-cta-btn:hover .hero-cta-icon {
    transform: translateX(3px);
  }

  /* Slide text animations */
  .hero-slide.active .hero-badge {
    animation: fadeSlideUp 0.8s cubic-bezier(0.22, 0.61, 0.36, 1) 0.2s both;
  }

  .hero-slide.active .hero-headline {
    animation: fadeSlideUp 0.8s cubic-bezier(0.22, 0.61, 0.36, 1) 0.4s both;
  }

  .hero-slide.active .hero-bottom {
    animation: fadeSlideUp 0.8s cubic-bezier(0.22, 0.61, 0.36, 1) 0.6s both;
  }

  .hero-slide.active .hero-cta {
    animation: fadeSlideUp 0.8s cubic-bezier(0.22, 0.61, 0.36, 1) 0.8s both;
  }

  @keyframes fadeSlideUp {
    from {
      opacity: 0;
      transform: translateY(35px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  /* Right edge vertical indicators */
  .hero-indicators {
    position: absolute;
    right: 30px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 5;
    display: flex;
    flex-direction: column;
    gap: 14px;

    .hero-indicator {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      border: 2px solid rgba(255, 255, 255, 0.35);
      background: transparent;
      cursor: pointer;
      transition: all 0.3s ease;
      padding: 0;

      &.active {
        background: #fff;
        border-color: #fff;
        box-shadow: 0 0 10px rgba(255, 255, 255, 0.4);
      }

      &:hover {
        border-color: rgba(255, 255, 255, 0.7);
      }
    }
  }

  /* Left/Right arrows */
  .hero-arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    z-index: 5;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.15);
    color: rgba(255, 255, 255, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    backdrop-filter: blur(4px);
    cursor: pointer;

    &:hover {
      background: rgba(255, 255, 255, 0.15);
      border-color: rgba(255, 255, 255, 0.3);
      color: #fff;
    }

    svg {
      width: 18px;
      height: 18px;
    }
  }

  .hero-arrow--left {
    left: 30px;
  }

  .hero-arrow--right {
    right: 70px;
  }

  /* Scroll hint */
  .hero-scroll-hint {
    position: absolute;
    bottom: 36px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 5;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .hero-scroll-line {
    width: 1px;
    height: 40px;
    background: linear-gradient(to bottom, rgba(255, 255, 255, 0.4), transparent);
    animation: scrollPulse 2s ease-in-out infinite;
  }

  @keyframes scrollPulse {
    0%, 100% { opacity: 0.4; transform: scaleY(0.6); }
    50% { opacity: 1; transform: scaleY(1); }
  }

  /* ===== About ===== */
  .about-section {
    padding: 90px 0;
    background: $light;
  }

  .about-row-new {
    display: grid;
    grid-template-columns: 1fr 1.25fr;
    gap: 80px;
    align-items: center;
  }

  .about-left {
    .about-label {
      font-size: 0.95rem;
      font-weight: 600;
      letter-spacing: 2px;
      color: $primary;
      margin-bottom: 1rem;
    }

    .about-heading {
      font-size: 2rem;
      font-weight: 700;
      line-height: 1.3;
      margin-bottom: 2rem;
      color: $heading;
    }

    .feature-items {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 1.5rem;
      margin-bottom: 2rem;

      .feature-item {
        display: flex;
        align-items: center;
        gap: 1rem;

        span {
          font-size: 2.2rem;
          color: $primary;
          flex-shrink: 0;
        }

        h5 {
          margin: 0;
          font-size: 1.05rem;
          font-weight: 700;
          color: $primary;
          line-height: 1.3;
        }
      }
    }

    .about-desc{
      font-size: 1rem;
      line-height: 1.8;
      margin-bottom: 2rem;
      color: $body;
    }

    .check-list {
      list-style: none;
      padding: 0;
      margin: 0 0 2rem;

      li {
        display: flex;
        align-items: center;
        gap: 12px;
        margin-bottom: 14px;
        font-size: 1.05rem;
        color: $body;

        .el-icon-check {
          color: $primary;
          font-size: 18px;
          flex-shrink: 0;
        }
      }
    }
  }

  .about-right {
    position: relative;

    .about-collage {
      position: relative;
    }

    /* 主图容器 */
    .collage-main {
      position: relative;
      z-index: 1;
       border-radius: 12px;
      overflow: hidden;
      box-shadow: 0 8px 32px rgba(0, 82, 204, .12);

      img {
        width: 100%;
        height: 420px;
        object-fit: cover;
        display: block;
        border-radius: 12px;
      }
    }

    /* 副图：右下角叠加展示 */
    .collage-sub {
      position: absolute;
      bottom: -20px;
      right: -20px;
      width: 45%;
      z-index: 2;
      border-radius: 12px;
      overflow: hidden;
      border: 4px solid #fff;
      box-shadow: 0 6px 24px rgba(0, 0, 0, .12);

      img {
        width: 100%;
        height: 180px;
        object-fit: cover;
        display: block;
      }
    }

    /* 徽章：左下角数据卡片 */
    .experience-badge {
      position: absolute;
      bottom: -20px;
      left: -20px;
      z-index: 5;
      background: $primary;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 20px 28px;
      border-radius: 12px;
      border: 4px solid #fff;
      box-shadow: 0 6px 24px rgba(0, 82, 204, .25);

      .badge-number {
        font-size: 2.8rem;
        font-weight: 800;
        color: #fff;
        line-height: 1;
      }

      .badge-label {
        color: rgba(255, 255, 255, .9);
        font-size: .85rem;
        font-weight: 500;
        margin-top: 6px;
        text-align: center;
        line-height: 1.3;
      }
    }
  }

  /* ===== CTA Banner ===== */
  .cta-banner {
    background: linear-gradient(90deg, $dark 0%, $primary-dark 100%);
    padding: 60px 0;

    .cta-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 2rem;
      flex-wrap: wrap;
    }

    .cta-text {
      h4 {
        color: $primary;
        font-size: 1rem;
        letter-spacing: 2px;
        text-transform: uppercase;
        margin-bottom: .75rem;
      }

      h1 {
        color: #fff;
        margin: 0;
        font-size: 2rem;
      }
    }
  }

  /* ===== Services - Card Grid ===== */
  .services-section-wrap {
    padding: 60px 0;
    background: $light;

    .section-title.text-center {
      margin-bottom: 50px;

      h4 {
        font-size: 1rem;
        letter-spacing: 3px;
        text-transform: uppercase;
        font-weight: 700;
        margin-bottom: .75rem;
      }

      .display-6 {
        font-size: 1.8rem;
        font-weight: 700;
        margin-bottom: .5rem;
        color: $heading;
      }
    }
  }

  .services-card-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 28px;
  }

  /* 服务卡片 */
  .service-card {
    display: flex;
    background: #fff;
    border-radius: 12px;
    overflow: hidden;
    min-height: 380px;
    position: relative;
    cursor: pointer;
    transition: transform 0.4s ease, box-shadow 0.4s ease;

    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);

      .service-card-hover-overlay {
        opacity: 1;
        visibility: visible;
      }

      .service-card-hover-overlay .hover-bg-img {
        transform: scale(1.08);
      }
    }
  }

  /* 默认状态：左侧内容区 */
  .service-card-content {
    flex: 1;
    padding: 32px 28px;
    display: flex;
    flex-direction: column;
    position: relative;
    z-index: 2;
    background: #fff;

    .service-card-icon {
      font-size: 2.4rem;
      color: #0A1628;
      margin-bottom: 20px;

      i {
        font-size: 2.4rem;
      }
    }

    .service-card-number {
      font-size: 1.1rem;
      font-weight: 700;
      color: #00bfa5;
      margin-bottom: 8px;
    }

    .service-card-title {
      font-size: 1.2rem;
      font-weight: 700;
      color: #0A1628;
      margin-bottom: 12px;
      line-height: 1.3;
    }

    .service-card-desc {
      font-size: 0.88rem;
      color: #6b7c93;
      line-height: 1.6;
      margin-bottom: 0;
      flex: 1;
    }

    .service-card-arrow {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 44px;
      height: 44px;
      border-radius: 50%;
      background: #f0ebe6;
      color: #0A1628;
      font-size: 16px;
      text-decoration: none;
      margin-top: 20px;
      transition: all 0.3s ease;
      flex-shrink: 0;

      &:hover {
        background: #e8e0d8;
      }
    }
  }

  /* 默认状态：右侧图片区 */
  .service-card-image {
    width: 42%;
    flex-shrink: 0;
    overflow: hidden;
    position: relative;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }

  /* 悬停浮层 */
  .service-card-hover-overlay {
    position: absolute;
    inset: 0;
    z-index: 10;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.45s ease, visibility 0.45s ease;
    overflow: hidden;
    border-radius: 12px;

    .hover-bg-img {
      position: absolute;
      inset: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.6s ease;
    }

    .hover-overlay-dark {
      position: absolute;
      inset: 0;
      background: linear-gradient(
        135deg,
        rgba(10, 22, 40, 0.92) 0%,
        rgba(10, 22, 40, 0.75) 50%,
        rgba(10, 22, 40, 0.60) 100%
      );
    }

    .hover-overlay-content {
      position: relative;
      z-index: 2;
      height: 100%;
      padding: 32px 28px;
      display: flex;
      flex-direction: column;
      color: #fff;
    }

    .hover-number {
      font-size: 1.1rem;
      font-weight: 700;
      color: #00bfa5;
      margin-bottom: 8px;
    }

    .hover-title {
      font-size: 1.3rem;
      font-weight: 700;
      color: #fff;
      margin-bottom: 12px;
      line-height: 1.3;
    }

    .hover-desc {
      font-size: 0.88rem;
      color: rgba(255, 255, 255, 0.8);
      line-height: 1.6;
      margin-bottom: 16px;
    }

    .hover-features {
      list-style: none;
      padding: 0;
      margin: 0 0 20px;
      flex: 1;

      li {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 8px;
        font-size: 0.82rem;
        color: rgba(255, 255, 255, 0.85);
        line-height: 1.5;

        .el-icon-check {
          color: #00bfa5;
          font-size: 13px;
          flex-shrink: 0;
        }
      }
    }

    .hover-arrow {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 44px;
      height: 44px;
      border-radius: 50%;
      background: #fff;
      color: #0A1628;
      font-size: 16px;
      text-decoration: none;
      transition: all 0.3s ease;
      flex-shrink: 0;

      &:hover {
        background: #f0f0f0;
        transform: translateX(3px);
      }
    }
  }


  /* ===== Branches / Network Map ===== */
  .branches-section {
    padding: 60px 0;
    background: $light;
    position: relative;
    overflow: hidden;

    .branches-bg-decoration {
      position: absolute;
      inset: 0;
      pointer-events: none;
      overflow: hidden;

      &::before {
        content: '';
        position: absolute;
        top: -200px;
        right: -200px;
        width: 600px;
        height: 600px;
        border-radius: 50%;
        background: radial-gradient(circle, rgba(0, 82, 204, .04) 0%, transparent 70%);
      }

      &::after {
        content: '';
        position: absolute;
        bottom: -150px;
        left: -150px;
        width: 500px;
        height: 500px;
        background: radial-gradient(circle, rgba(59, 127, 255, .05) 0%, transparent 70%);
        border-radius: 50%;
      }
    }
  }

  /* --- Branch Tabs --- */
  .branch-tabs {
    display: flex;
    gap: 10px;
    margin-top: 24px;
    margin-bottom: 4px;
    flex-wrap: wrap;

    .branch-tab {
      padding: 8px 22px;
      border-radius: 20px;
      border: 1px solid rgba(0, 82, 204, .12);
      background: transparent;
      color: $body;
      font-size: 13px;
      font-weight: 600;
      cursor: pointer;
      transition: all .3s ease;

      &:hover {
        border-color: $primary;
        color: $primary;
      }

      &.active {
        background: $primary;
        color: #fff;
        border-color: $primary;
        box-shadow: 0 4px 14px rgba(0, 82, 204, .25);
      }
    }
  }

  /* --- Map Layout --- */
  .map-layout {
    display: grid;
    grid-template-columns: 1.6fr 1fr;
    gap: 20px;
    margin-top: 28px;
    align-items: stretch;
  }

  .china-map-wrap {
    position: relative;
    background: linear-gradient(160deg, #EEF4FF 0%, #F7FAFF 40%, #F0F6FF 100%);
    border-radius: 20px;
    padding: 0;
    box-shadow: 0 8px 40px rgba(0, 82, 204, .08), 0 1px 3px rgba(0, 0, 0, .04);
    border: 1px solid rgba(0, 82, 204, .06);
    overflow: hidden;

    .china-map-echarts {
      width: 100%;
      height: 720px;
    }

    .map-hint {
      position: absolute;
      bottom: 14px;
      left: 50%;
      transform: translateX(-50%);
      font-size: 12px;
      color: $silver;
      display: flex;
      align-items: center;
      gap: 6px;
      background: rgba(255, 255, 255, .85);
      padding: 6px 18px;
      border-radius: 20px;
      backdrop-filter: blur(8px);
      z-index: 3;
      pointer-events: none;
      border: 1px solid rgba(0, 82, 204, .06);
    }
  }

  /* --- Detail Panel --- */
  .branch-detail-panel {
    background-color: #fff;
    border-radius: 20px;
    padding: 0;
    box-shadow: 0 8px 40px rgba(0, 82, 204, .08), 0 1px 3px rgba(0, 0, 0, .04);
    border: 1px solid rgba(0, 82, 204, .06);
    min-height: 0;
    display: flex;
    flex-direction: column;
    position: sticky;
    top: 100px;
    overflow: hidden;

    .detail-image-zone {
      flex: 3;
      min-height: 0;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      position: relative;

      .image-fade {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 100px;
        background: linear-gradient(
          to bottom,
          rgba(0, 82, 204, 0) 0%,
          rgba(0, 82, 204, .06) 50%,
          rgba(255, 255, 255, 1) 100%
        );
        pointer-events: none;
      }
    }

    .detail-content {
      flex: 1;
      padding: 20px 32px 24px;
      animation: fadeSlideIn .4s ease;
    }

    .detail-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 14px;
      padding-bottom: 12px;
      border-bottom: 2px solid rgba(0, 82, 204, .08);

      .detail-city-badge {
        display: flex;
        align-items: center;
        gap: 10px;
        font-size: 1.5rem;
        font-weight: 700;
        color: $primary;

        i {
          color: $primary;
          font-size: 1.3rem;
        }
      }

      .detail-year {
        font-size: .85rem;
        color: $primary;
        background: rgba(0, 82, 204, .06);
        padding: 5px 16px;
        border-radius: 20px;
        font-weight: 600;
      }
    }

    .detail-desc {
      font-size: .88rem;
      line-height: 1.6;
      color: $body;
      margin-bottom: 16px;
      flex: 1;
    }

    .detail-stats {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 10px;
      margin-bottom: 16px;

      .detail-stat {
        display: flex;
        align-items: center;
        gap: 10px;
        background: $light;
        padding: 10px 14px;
        border-radius: 12px;
        transition: all .3s ease;
        border: 1px solid transparent;

        &:hover {
          background: rgba(0, 82, 204, .04);
          border-color: rgba(0, 82, 204, .08);
        }

        .stat-icon-wrap {
          width: 36px;
          height: 36px;
          border-radius: 10px;
          background: linear-gradient(135deg, $primary, $primary-light);
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          box-shadow: 0 3px 10px rgba(0, 82, 204, .18);

          i {
            font-size: 17px;
            color: #fff;
          }
        }

        .stat-info {
          .stat-label {
            font-size: .7rem;
            color: #6B8AB5;
            margin-bottom: 1px;
          }

          .stat-value {
            font-size: .95rem;
            font-weight: 700;
            color: $primary;
          }
        }
      }
    }

    .detail-contact {
      margin-bottom: 12px;
      border-top: 1px solid rgba(0, 82, 204, .06);
      padding-top: 12px;

      .contact-item {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 6px 0;
        font-size: .82rem;
        color: $body;
        border-bottom: 1px solid rgba(0, 0, 0, .03);

        &:last-child {
          border-bottom: none;
        }

        i {
          width: 26px;
          height: 26px;
          border-radius: 6px;
          background: rgba(0, 82, 204, .06);
          display: flex;
          align-items: center;
          justify-content: center;
          color: $primary;
          font-size: 13px;
          flex-shrink: 0;
        }

        span {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }

    .detail-cta {
      display: block;
      width: 100%;
      text-align: center;
      padding: 14px;
      font-size: 15px;
      border-radius: 8px;
    }
  }

  .fade-slide-enter-active {
    transition: all .35s ease;
  }

  .fade-slide-leave-active {
    transition: all .2s ease;
  }

  .fade-slide-enter {
    opacity: 0;
    transform: translateX(20px);
  }

  .fade-slide-leave-to {
    opacity: 0;
    transform: translateX(-20px);
  }

  @keyframes fadeSlideIn {
    from { opacity: 0; transform: translateY(12px); }
    to { opacity: 1; transform: translateY(0); }
  }

  /* --- Overseas Network --- */
  .overseas-network {
    margin-top: 80px;
    text-align: center;

    .overseas-header {
      margin-bottom: 40px;

      .overseas-title {
        font-size: 1.6rem;
        font-weight: 700;
        color: $heading;
        margin-bottom: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;

        i {
          color: $primary;
          font-size: 1.4rem;
        }
      }

      .overseas-subtitle {
        font-size: 1rem;
        color: $body;
        max-width: 600px;
        margin: 0 auto;
      }
    }

    .overseas-regions {
      display: grid;
      grid-template-columns: repeat(6, 1fr);
      gap: 20px;
    }

    .region-card {
      background: #fff;
      border-radius: 12px;
      padding: 28px 16px;
      border: 1px solid rgba(0, 82, 204, .08);
      box-shadow: 0 2px 12px rgba(0, 0, 0, .04);
      transition: all .35s ease;
      cursor: default;

      &:hover {
        transform: translateY(-6px);
        box-shadow: 0 12px 32px rgba(0, 82, 204, .12);
        border-color: $primary;

        .region-icon {
          transform: scale(1.2);
        }

        .region-name {
          color: $primary;
        }
      }

      .region-icon {
        font-size: 2.4rem;
        margin-bottom: 12px;
        transition: transform .35s ease;
      }

      .region-name {
        font-size: 1rem;
        font-weight: 700;
        color: $heading;
        margin-bottom: 8px;
        transition: color .3s ease;
      }

      .region-countries {
        font-size: .8rem;
        color: $silver;
        line-height: 1.5;
      }
    }
  }

  /* ===== Memberships ===== */
  .memberships-section {
    padding: 60px 0;
    position: relative;
    background: $light;
    .memberships-bg-decoration {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      pointer-events: none;
    }

    .section-header {
      margin-bottom: 50px;
      position: relative;

      &.center {
        text-align: center;
      }

      .section-title {
        color: $heading;
        font-size: 2.6rem;
        font-weight: 700;
        letter-spacing: -0.5px;
        margin-bottom: 0;

        &::after {
          content: '';
          display: block;
          background: linear-gradient(to right, $primary, $primary-light);
          height: 4px;
          width: 80px;
          border-radius: 2px;
          margin: 18px auto 0;
        }
      }

      .section-subtitle {
        color: $body;
        font-size: 1rem;
        font-weight: 400;
        margin-top: 15px;
      }
    }

    /* --- Photo Wall --- */
    .photo-wall {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-auto-rows: 200px;
      gap: 16px;
      max-width: 1100px;
      margin: 0 auto;
      padding: 0 20px;
    }

    .photo-wall-item {
      position: relative;
      border-radius: 12px;
      overflow: hidden;
      cursor: pointer;
      background: #fff;
      box-shadow: 0 2px 12px rgba(0, 0, 0, .06);
      transition: all .4s cubic-bezier(.4, 0, .2, 1);
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 20px;

      /* 大小变化：大/中/小 */
      &.photo-size-0 {
        grid-row: span 2;
        grid-column: span 1;
      }

      &.photo-size-1 {
        grid-row: span 1;
        grid-column: span 2;
      }

      &.photo-size-2 {
        grid-row: span 1;
        grid-column: span 1;
      }

      &:hover {
        transform: translateY(-4px);
        box-shadow: 0 12px 32px rgba(0, 82, 204, .18);

        .photo-wall-overlay {
          opacity: 1;
        }

        .photo-wall-img {
          transform: scale(1.06);
        }
      }
    }

    .photo-wall-img {
      max-width: 100%;
      max-height: 100%;
      width: auto;
      height: auto;
      object-fit: contain;
      transition: transform .4s ease;
      display: block;
    }

    .photo-wall-overlay {
      position: absolute;
      inset: 0;
      background: linear-gradient(180deg, transparent 40%, rgba(0, 82, 204, .85) 100%);
      display: flex;
      align-items: flex-end;
      justify-content: center;
      padding: 20px;
      opacity: 0;
      transition: opacity .4s ease;
    }

    .photo-wall-name {
      color: #fff;
      font-size: 15px;
      font-weight: 600;
      text-align: center;
      text-shadow: 0 1px 4px rgba(0, 0, 0, .2);
      letter-spacing: .5px;
    }
  }

  video.hero-media {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  /* ===== Stats ===== */
  .stats-section {
    padding: 50px 0;
    background: linear-gradient(135deg, $dark 0%, darken($primary-dark, 10%) 100%);
  }

  .stats-row {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 50px;
    text-align: center;
  }

  .stat-card {
    padding: 30px 20px;
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.1);
    transition: all .3s ease;

    &:hover {
      background: rgba(255, 255, 255, 0.1);
      transform: translateY(-4px);
    }
  }

  .stat-number {
    font-size: 2.4rem;
    font-weight: 800;
    color: #fff;
    line-height: 1;
    margin-bottom: 12px;
  }

  .stat-label {
    font-size: 1rem;
    color: rgba(255, 255, 255, 0.7);
    font-weight: 500;
  }

  /* ===== Partners ===== */
  .partners-section {
    padding: 60px 0;
    background: $light;
    overflow: hidden;
  }

  .partner-track-wrap {
    margin-top: 40px;

    .track-label {
      font-size: 1.15rem;
      font-weight: 700;
      color: $heading;
      text-transform: uppercase;
      letter-spacing: 3px;
      margin-bottom: 20px;
      padding-left: 4px;
    }
  }

  .partner-track {
    overflow: hidden;
    position: relative;
    padding: 20px 0;

    &::before, &::after {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      width: 100px;
      z-index: 2;
      pointer-events: none;
    }
    &::before {
      left: 0;
      background: linear-gradient(90deg, $light, transparent);
    }
    &::after {
      right: 0;
      background: linear-gradient(270deg, $light, transparent);
    }
  }

  .partner-track-inner {
    display: flex;
    align-items: center;
    gap: 60px;
    animation: scrollTrack 30s linear infinite;
    width: max-content;
  }

  .partner-track-reverse .partner-track-inner {
    animation-direction: reverse;
  }

  .partner-logo {
    height: 60px;
    width: auto;
    object-fit: contain;
    opacity: 1;
    transition: all .3s ease;
    flex-shrink: 0;

    &:hover {
      opacity: .85;
      transform: scale(1.05);
    }
  }

  @keyframes scrollTrack {
    0% { transform: translateX(0); }
    100% { transform: translateX(-50%); }
  }

  /* ===== News ===== */
  .news-section {
    padding: 60px 0;
    background: #fff;
  }

  .news-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 36px;
    margin-top: 50px;
  }

  .news-card {
    background: $light;
    border-radius: 12px;
    padding: 32px;
    display: flex;
    gap: 24px;
    transition: all .3s ease;
    border: 1px solid transparent;

    &:hover {
      background: #fff;
      border-color: rgba(0, 82, 204, .12);
      box-shadow: 0 8px 32px rgba(0, 82, 204, .1);
      transform: translateY(-4px);
    }
  }

  .news-date {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-width: 60px;
    padding: 12px;
    background: $primary;
    border-radius: 8px;
    color: #fff;
    flex-shrink: 0;

    .date-day {
      font-size: 1.8rem;
      font-weight: 800;
      line-height: 1;
    }
    .date-month {
      font-size: .75rem;
      opacity: .8;
      margin-top: 4px;
    }
  }

  .news-body {
    flex: 1;

    .news-title {
      font-size: 1.1rem;
      font-weight: 700;
      color: $heading;
      margin-bottom: 10px;
      line-height: 1.4;
    }

    .news-summary {
      font-size: .9rem;
      color: $body;
      line-height: 1.7;
      margin-bottom: 14px;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    .news-link {
      font-size: .85rem;
      color: $primary;
      font-weight: 600;
      text-decoration: none;
      display: inline-flex;
      align-items: center;
      gap: 4px;
      transition: gap .3s ease;

      &:hover {
        gap: 8px;
      }
    }
  }

  /* ===== Animations / Reveal ===== */
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity .3s ease;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  .reveal {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity .9s ease-out, transform .9s ease-out;
  }

  .reveal.revealed {
    opacity: 1;
    transform: translateY(0);
  }

  .reveal-delay-1 {
    transition-delay: .15s;
  }

  .reveal-delay-2 {
    transition-delay: .3s;
  }

  .reveal-delay-3 {
    transition-delay: .45s;
  }

  /* ===== Responsive ===== */
  @media (max-width: 1100px) {

    .about-row-new,
    .projects-row {
      grid-template-columns: 1fr;
      gap: 40px;
    }

    .services-card-grid {
      grid-template-columns: repeat(2, 1fr);
    }

    .map-layout {
      grid-template-columns: 1fr;
      gap: 30px;
    }

    .branch-detail-panel {
      position: static;
      min-height: auto;
    }

    .overseas-regions {
      grid-template-columns: repeat(3, 1fr) !important;
    }

    .stats-row {
      grid-template-columns: repeat(2, 1fr);
      gap: 20px;
    }

    .news-grid {
      grid-template-columns: 1fr;
      gap: 20px;
    }

    .memberships-section {
      padding: 60px 0;
    }

    .photo-wall {
      grid-template-columns: repeat(2, 1fr);
      grid-auto-rows: 180px;
      gap: 12px;
    }

    .photo-wall-item.photo-size-1 {
      grid-column: span 1;
    }

  }

  @media (max-width: 1024px) {
    .hero-content {
      padding: 0 5%;
    }

    .hero-headline {
      font-size: clamp(2rem, 4vw, 3rem);
    }

    .hero-bottom {
      gap: 30px;
    }
  }

  @media (max-width: 768px) {
    .hero-carousel {
      height: 70vh;
      min-height: 420px;
    }

    .hero-content {
      padding: 0 5%;
      justify-content: flex-end;
      padding-bottom: 10%;
    }

    .hero-headline {
      font-size: 2rem;
    }

    .hero-bottom {
      flex-direction: column;
      gap: 16px;
    }

    .hero-divider-line {
      display: none;
    }

    .hero-desc {
      font-size: 0.9rem;
    }

    .hero-arrow {
      display: none;
    }

    .hero-indicators {
      right: 16px;
    }

    .about-section,
    .services-section-wrap,
    .projects-section,
    .branches-section,
    .memberships-section,
    .testimonial-section,
    .faq-section {
      padding: 60px 0;
    }

    .display-6 {
      font-size: 1.8rem;
    }

    .about-row-new {
      grid-template-columns: 1fr;
      gap: 40px;
    }

    .about-left .about-heading {
      font-size: 2rem;
    }

    .about-right {
      .collage-main img {
        height: 280px;
        clip-path: none;
        -webkit-clip-path: none;
      }

      .collage-sub {
        position: relative;
        top: auto;
        right: auto;
        bottom: auto;
        left: auto;
        width: 72%;
        height: auto;
        margin-top: -30px;
        margin-left: auto;
        border-radius: 8px;

        img { height: 200px; }

        &::before,
        &::after {
          display: none;
        }
      }

      .experience-badge {
        position: relative;
        top: auto;
        right: auto;
        bottom: auto;
        left: auto;
        width: auto;
        height: auto;
        display: inline-flex;
        margin-top: -12px;
        margin-right: 0;
        border-radius: 8px;

        &::before,
        &::after {
          display: none;
        }
      }
    }
    .services-card-grid {
      grid-template-columns: 1fr;
    }

    .service-card {
      min-height: 320px;

      .service-card-content {
        padding: 24px 20px;

        .service-card-title {
          font-size: 1.1rem;
        }
      }

      .service-card-image {
        width: 38%;
      }
    }

    .overseas-regions {
      grid-template-columns: repeat(2, 1fr) !important;
    }

    .stat-number {
      font-size: 2.4rem;
    }

    .partner-logo {
      height: 44px;
    }
    .partner-track-inner {
      gap: 40px;
    }

    .news-section {
      padding: 60px 0;
    }
    .news-card {
      padding: 24px;
    }

    .photo-wall {
      grid-template-columns: repeat(2, 1fr);
      grid-auto-rows: 160px;
      gap: 10px;
    }

    .photo-wall-name {
      font-size: 13px;
    }

    .about-left .feature-items {
      grid-template-columns: 1fr;
    }

    .cta-banner .cta-text h1 {
      font-size: 1.4rem;
    }
  }

  @media (max-width: 480px) {
    .hero-caption {
      .hero-title-line1 {
        font-size: 1.3rem;
      }

      .hero-title-line2 {
        font-size: 1.8rem;
      }

      .hero-desc {
        display: none;
      }

      .hero-tag {
        font-size: 0.65rem;
        padding: 4px 14px;
      }
    }
  }
</style>